/**
 * search-tag-exclusions.js
 *
 * Globally excludes products tagged with any of the following from all
 * search results (full-page form submissions and predictive/AJAX search):
 *   nosearch, no_rebuy_upsell, free-gift, exclude
 */
(function () {
  var EXCLUDED_TAGS = ['nosearch', 'no_rebuy_upsell', 'free-gift', 'exclude'];
  var EXCLUSION_SUFFIX = EXCLUDED_TAGS.map(function (t) {
    return ' NOT tag:' + t;
  }).join('');

  /**
   * Strip exclusion tokens from a string for clean display on the results page.
   */
  function stripExclusions(value) {
    var result = value;
    EXCLUDED_TAGS.forEach(function (t) {
      // Escape hyphens for the regex
      var escaped = t.replace(/-/g, '\\-');
      result = result.replace(new RegExp('\\s*NOT tag:' + escaped, 'g'), '');
    });
    return result.trim();
  }

  /**
   * Intercept all search form submissions (capture phase) and append the
   * tag exclusion suffix to the q value before the form is submitted.
   */
  function interceptFormSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var qInput = form.querySelector('input[name="q"]');
    if (!qInput) return;
    var query = qInput.value.trim();
    if (!query) return;
    // Guard against double-appending
    if (query.indexOf(' NOT tag:') === -1) {
      qInput.value = query + EXCLUSION_SUFFIX;
    }
  }

  /**
   * On page load, strip the exclusion suffix from every visible search input
   * so the results page shows the clean user query, not the raw Shopify syntax.
   */
  function cleanDisplayedTerms() {
    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      if (input.value && input.value.indexOf(' NOT tag:') !== -1) {
        input.value = stripExclusions(input.value);
      }
    });
  }

  // Capture phase ensures this runs before any other submit handler.
  document.addEventListener('submit', interceptFormSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanDisplayedTerms);
  } else {
    cleanDisplayedTerms();
  }
})();
